import { render, staticRenderFns } from "./param.vue?vue&type=template&id=3fa6c6e4&scoped=true"
import script from "./param.vue?vue&type=script&lang=js"
export * from "./param.vue?vue&type=script&lang=js"
import style0 from "./param.vue?vue&type=style&index=0&id=3fa6c6e4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fa6c6e4",
  null
  
)

export default component.exports